import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TimeZone } from '@models/settings.model';

@Injectable()
@Pipe({
	name: 'timeZoneFilter'
})
export class TimeZoneFilter implements PipeTransform {
	transform(timeZone: TimeZone): string {
		const zoneOffset =
			timeZone.zoneOffset === 'Z' ? '00:00' : timeZone.zoneOffset;
		const name = timeZone.name.replace('/', ' - ');
		return `(${zoneOffset}) ${name}`;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/pipes/time-zone-filter/time-zone-filter.ts